export {
  BOTCreditCard,
  BOTCreditCardTeaser
} from '../BOTCreditCard'
